export class UpdateProposalEstimateRequestStatusDTO {
    EstimateRequestId: Number;
    StatusId: Number;
    constructor() {
       
    }
}
